import React from 'react';

const Vue_Lifecycle = () => {
  return (
    <div>
      <h1>Vue_Lifecycle Component</h1>
      <p>This is the Vue_Lifecycle tutorial page.</p>
    </div>
  );
}

export default Vue_Lifecycle;
